module.exports = __webpack_public_path__ + "static/media/work-past-schedule-icon.103f9453.svg";